import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import 'font-awesome/css/font-awesome.min.css';

const Nav = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleNavigate = (to) => {
    navigate(to);
  };

  return (
    <React.Fragment>
      <div className="w3-top">
        <div className="w3-bar w3-black w3-card w3-left-align w3-xlarge">
          {/* Mobile Menu Toggle Button */}
          <button
            className="w3-bar-item w3-button w3-hide-medium w3-hide-large w3-right w3-padding-large w3-hover-white w3-large w3-yellow"
            onClick={toggleMobileMenu}
            title="Toggle Navigation Menu"
          >
            <i className="fa fa-bars"></i>
          </button>

          {/* Logo */}
          <div className="w3-bar-item w3-hide-small" style={{display:'flex', justifyContent: 'center', alignItems: 'center' }}>
          <a
            href="/"
            className="w3-bar-item w3-button w3-black w3-hover-yellow w3-padding"
            aria-label="Go to Home Page"
          >
            <img
              src="logo-aprenderia.png"
              alt="Aprender IA Logo"
              style={{ width: "45px" }}
            />
          </a>
          </div>

          {/* Desktop Navigation Links */}
          <div className="w3-bar-item w3-hide-small">
            <Link
              to="/acerca-de-aprender-ia"
              title="Acerca de Aprender IA - Aprender IA"
              className="w3-button w3-padding-large w3-hover-yellow"
              aria-label="Acerca de Aprender IA"
              onClick={() => handleNavigate("/acerca-de-aprender-ia")}
            >
              Acerca de Aprender IA
            </Link>
            {/* Dropdown for "Cursos Gratuitos" */}
            <div className="w3-dropdown-hover w3-hide-small">
              <button
                className="w3-button w3-padding-large w3-hover-yellow"
                title="Cursos Gratuitos"
                onClick={() => handleNavigate("/curso-python-ia")}
              >
                Cursos Gratuitos <i className="fa fa-caret-down"></i>
              </button>
              <div className="w3-dropdown-content w3-card-4 w3-bar-block">
                <Link
                  to="/curso-python-ia"
                  className="w3-bar-item w3-button w3-hover-yellow"
                  aria-label="Python + IA Course"
                >
                  Python + IA
                </Link>
                <Link
                  to="/curso-prompt-engineering"
                  className="w3-bar-item w3-button w3-hover-yellow"
                  aria-label="Prompt Engineering Course"
                >
                  Prompt Engineering
                </Link>
              </div>
            </div>
            {/* Dropdown for "Tutoriales" */}
            <div className="w3-dropdown-hover w3-hide-small">
              <button
                className="w3-button w3-padding-large w3-hover-yellow"
                title="Tutoriales"
                onClick={() => handleNavigate("/inteligencia-artificial-que-es")}
              >
                Tutoriales <i className="fa fa-caret-down"></i>
              </button>
              <div className="w3-dropdown-content w3-card-4 w3-bar-block">
                <Link
                  to="/inteligencia-artificial-que-es"
                  className="w3-bar-item w3-button w3-hover-yellow"
                  aria-label="Introduction to AI Tutorial"
                >
                  Inteligencia Aritificial qué es
                </Link>
                <Link
                  to="/machine-learning-que-es"
                  className="w3-bar-item w3-button w3-hover-yellow"
                  aria-label="Machine Learning Tutorial"
                >
                  Machine Learning qué es
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          id="navDemo"
          className={`w3-bar-block w3-yellow w3-hide w3-hide-large w3-hide-medium w3-large w3-show-small ${
            mobileMenuOpen ? "w3-show" : ""
          }`}
        >
          <div className="w3-dropdown-hover">
            <button
              className="w3-bar-item w3-button w3-padding-large w3-hover-yellow"
              title="Cursos Gratuitos"
              onClick={() => handleNavigate("/curso-python-ia")}
            >
              Cursos Gratuitos <i className="fa fa-caret-down"></i>
            </button>
            <div className="w3-dropdown-content w3-card-4 w3-bar-block">
              <Link
                to="/curso-python-ia"
                className="w3-bar-item w3-button w3-hover-yellow"
                aria-label="Python + IA Course (Mobile)"
              >
                Python + IA
              </Link>
              <Link
                  to="/curso-prompt-engineering"
                  className="w3-bar-item w3-button w3-hover-yellow"
                  aria-label="Prompt Engineering Course (Mobile)"
                >
                  Prompt Engineering
                </Link>
            </div>
          </div>
          <div className="w3-dropdown-hover">
            <button
              className="w3-bar-item w3-button w3-padding-large w3-hover-yellow"
              title="Tutoriales"
              onClick={() => handleNavigate("/inteligencia-artificial-que-es")}
            >
              Tutoriales <i className="fa fa-caret-down"></i>
            </button>
            <div className="w3-dropdown-content w3-card-4 w3-bar-block">
              <Link
                to="/inteligencia-artificial-que-es"
                className="w3-bar-item w3-button w3-hover-yellow"
                aria-label="Introduction to AI Tutorial (Mobile)"
              >
                Inteligencia Aritificial qué es
              </Link>
              <Link
                  to="/machine-learning-que-es"
                  className="w3-bar-item w3-button w3-hover-yellow"
                  aria-label="Machine Learning Tutorial (Mobile)"
                >
                  Machine Learning qué es
                </Link>
            </div>
          </div>
          <Link
              to="/acerca-de-aprender-ia"
              className="w3-button w3-padding-large w3-hover-yellow"
              aria-label="Acerca de Aprender IA (Mobile)"
              onClick={() => handleNavigate("/acerca-de-aprender-ia")}
            >
              Acerca de Aprender IA
            </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Nav;